import { ICategoriaEmpresa } from './categoria-empresa.model';

export interface ICategoriaAgricola {
  id?: number;
  nombre?: string | null;
  categoriaEmpresa?: ICategoriaEmpresa | null;
}

export class CategoriaAgricola implements ICategoriaAgricola {
  constructor(public id?: number, public nombre?: string | null, public categoriaEmpresa?: ICategoriaEmpresa | null) {}
}
